import { render, staticRenderFns } from "./mapText.vue?vue&type=template&id=2e84b240&scoped=true&"
var script = {}
import style0 from "./mapText.vue?vue&type=style&index=0&id=2e84b240&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e84b240",
  null
  
)

export default component.exports